import React from 'react';
import { Button } from '../../../components/ui/button';
import { Input } from '../../../components/ui/input';
import { Label } from '../../../components/ui/label';
import { iaApi } from '../../../lib/api';
import { Download, FileText, Loader2, Sparkles, Trash2, Upload } from 'lucide-react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from '../../../components/ui/dialog';
export const EscrituraDialog = ({ analizandoEscritura, error, escrituraAnalisis, escrituraFile, fetchData, isEscrituraDialogOpen, propietarios, selectedUnidadEscritura, setAnalizandoEscritura, setEscrituraAnalisis, setEscrituraFile, setIsEscrituraDialogOpen, setSelectedUnidadEscritura, toast }) => {
  return (
      <Dialog open={isEscrituraDialogOpen} onOpenChange={(open) => { setIsEscrituraDialogOpen(open); if (!open) { setEscrituraFile(null); setEscrituraAnalisis(null); } }}>
        <DialogContent className="sm:max-w-lg">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2">
              <FileText className="w-5 h-5 text-purple-600" />
              Escritura - {selectedUnidadEscritura?.nombre_unidad}
            </DialogTitle>
          </DialogHeader>
          
          <div className="space-y-4">
            {/* Si ya tiene escritura cargada, mostrar opciones */}
            {selectedUnidadEscritura?.escritura_archivo && (
              <div className="bg-green-50 border border-green-200 rounded-lg p-4">
                <div className="flex items-center justify-between mb-3">
                  <div className="flex items-center gap-2">
                    <FileText className="w-5 h-5 text-green-600" />
                    <div>
                      <p className="font-medium text-green-800">{selectedUnidadEscritura.escritura_archivo.filename}</p>
                      <p className="text-xs text-green-600">
                        {(selectedUnidadEscritura.escritura_archivo.size / 1024).toFixed(1)} KB
                        {selectedUnidadEscritura.escritura_archivo.uploaded_at && (
                          <> · Cargado: {new Date(selectedUnidadEscritura.escritura_archivo.uploaded_at).toLocaleDateString('es-AR')}</>
                        )}
                      </p>
                    </div>
                  </div>
                  <div className="flex gap-2">
                    <Button
                      variant="outline"
                      size="sm"
                      onClick={async () => {
                        try {
                          const token = localStorage.getItem('auth_token');
                          const response = await fetch(iaApi.downloadEscrituraUrl(selectedUnidadEscritura.unidad_id), {
                            headers: { 'Authorization': `Bearer ${token}` }
                          });
                          if (!response.ok) throw new Error('Error al descargar');
                          const blob = await response.blob();
                          const url = window.URL.createObjectURL(blob);
                          const a = document.createElement('a');
                          a.href = url;
                          a.download = selectedUnidadEscritura.escritura_archivo.filename || 'escritura.pdf';
                          document.body.appendChild(a);
                          a.click();
                          window.URL.revokeObjectURL(url);
                          document.body.removeChild(a);
                        } catch (err) {
                          toast.error('Error al descargar el archivo');
                        }
                      }}
                    >
                      <Download className="w-4 h-4 mr-1" />
                      Descargar
                    </Button>
                  </div>
                </div>
                
                {/* Mostrar datos extraídos */}
                {escrituraAnalisis && !escrituraAnalisis.parse_error && (
                  <div className="mt-3 pt-3 border-t border-green-200 space-y-2 text-sm">
                    <p className="font-medium text-green-800">Datos extraídos por IA:</p>
                    {escrituraAnalisis.nomenclatura_catastral && (
                      <p><span className="text-green-600">Nomenclatura:</span> {escrituraAnalisis.nomenclatura_catastral}</p>
                    )}
                    {escrituraAnalisis.propietarios?.length > 0 && (
                      <p><span className="text-green-600">Propietarios:</span> {escrituraAnalisis.propietarios.map(p => p.nombre).join(', ')}</p>
                    )}
                    {escrituraAnalisis.superficies?.total_m2 && (
                      <p><span className="text-green-600">Superficie:</span> {escrituraAnalisis.superficies.total_m2} m²</p>
                    )}
                  </div>
                )}
              </div>
            )}
            
            {/* Upload de nueva escritura */}
            <div className="space-y-3">
              <Label>{selectedUnidadEscritura?.escritura_archivo ? 'Cambiar escritura' : 'Cargar escritura'}</Label>
              <div className="bg-gradient-to-r from-purple-50 to-blue-50 border border-purple-200 rounded-lg p-4">
                <div className="flex items-center gap-2 mb-2">
                  <Sparkles className="w-4 h-4 text-purple-600" />
                  <span className="text-sm font-medium text-purple-900">Análisis automático con IA</span>
                </div>
                <p className="text-xs text-purple-700 mb-3">
                  Al cargar la escritura, la IA extraerá automáticamente los datos de la propiedad.
                </p>
                
                <div className="flex items-center gap-3">
                  <Input
                    type="file"
                    accept=".pdf,image/*"
                    onChange={(e) => setEscrituraFile(e.target.files[0])}
                    className="flex-1"
                  />
                  <Button
                    type="button"
                    disabled={!escrituraFile || analizandoEscritura}
                    onClick={async () => {
                      if (!escrituraFile || !selectedUnidadEscritura) return;
                      setAnalizandoEscritura(true);
                      try {
                        const res = await iaApi.analizarEscritura(escrituraFile, selectedUnidadEscritura.unidad_id, true);
                        if (res.data.ok) {
                          setEscrituraAnalisis(res.data.analisis);
                          toast.success('Escritura cargada y analizada');
                          // Recargar datos para ver cambios
                          fetchData();
                          // Actualizar el estado local
                          setSelectedUnidadEscritura(prev => ({
                            ...prev,
                            escritura_archivo: {
                              filename: escrituraFile.name,
                              size: escrituraFile.size,
                              uploaded_at: new Date().toISOString()
                            },
                            escritura_analisis: res.data.analisis
                          }));
                          setEscrituraFile(null);
                        } else {
                          toast.error('Error al analizar la escritura');
                        }
                      } catch (err) {
                        console.error('Error:', err);
                        toast.error(err.response?.data?.detail || 'Error al cargar');
                      } finally {
                        setAnalizandoEscritura(false);
                      }
                    }}
                    className="bg-purple-600 hover:bg-purple-700"
                  >
                    {analizandoEscritura ? (
                      <>
                        <Loader2 className="w-4 h-4 mr-2 animate-spin" />
                        Analizando...
                      </>
                    ) : (
                      <>
                        <Upload className="w-4 h-4 mr-2" />
                        Cargar
                      </>
                    )}
                  </Button>
                </div>
                {escrituraFile && (
                  <p className="text-xs text-slate-500 mt-2">
                    Archivo: {escrituraFile.name} ({(escrituraFile.size / 1024).toFixed(1)} KB)
                  </p>
                )}
              </div>
            </div>
            
            {/* Botón para eliminar escritura existente */}
            {selectedUnidadEscritura?.escritura_archivo && (
              <div className="flex justify-end">
                <Button
                  variant="ghost"
                  size="sm"
                  className="text-red-600 hover:text-red-700 hover:bg-red-50"
                  onClick={async () => {
                    if (!confirm('¿Eliminar la escritura cargada?')) return;
                    try {
                      await iaApi.deleteEscritura(selectedUnidadEscritura.unidad_id);
                      toast.success('Escritura eliminada');
                      setSelectedUnidadEscritura(prev => ({
                        ...prev,
                        escritura_archivo: null,
                        escritura_analisis: null
                      }));
                      setEscrituraAnalisis(null);
                      fetchData();
                    } catch (err) {
                      toast.error('Error al eliminar');
                    }
                  }}
                >
                  <Trash2 className="w-4 h-4 mr-1" />
                  Eliminar escritura
                </Button>
              </div>
            )}
          </div>
          
          <DialogFooter>
            <Button variant="outline" onClick={() => setIsEscrituraDialogOpen(false)}>Cerrar</Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
  );
};
